/** Направления для шага 2 онбординга */
export const ONBOARDING_SPORTS = [
  { id: "judo", name: "Дзюдо", icon: "🥋", label: "Дзюдо" },
  { id: "sambo", name: "Самбо", icon: "🤼", label: "Самбо" },
  { id: "boxing", name: "Бокс", icon: "🥊", label: "Бокс" },
  { id: "karate", name: "Карате", icon: "🥋", label: "Карате" },
  { id: "taekwondo", name: "Тхэквондо", icon: "🦶", label: "Тхэквондо" },
  { id: "ofp", name: "ОФП", icon: "🏋️", label: "ОФП" },
  { id: "football", name: "Футбол", icon: "⚽", label: "Футбол" },
  { id: "hockey", name: "Хоккей", icon: "🏒", label: "Хоккей" },
];

export function isOnboardingPresetSport(name) {
  const n = String(name || "").trim();
  return ONBOARDING_SPORTS.some((s) => s.name === n);
}

export function emptyDirectionSelection() {
  return { presets: [], customs: [], customDraft: "" };
}

export function collectDirectionNames(selection) {
  const pending = String(selection.customDraft || "").trim();
  const all = [...selection.presets, ...selection.customs];
  if (pending) all.push(pending);
  const seen = new Set();
  const out = [];
  for (const raw of all) {
    const n = String(raw || "").trim();
    if (!n) continue;
    const key = n.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(n);
  }
  return out;
}

export function selectionFromDirections(directions) {
  const presets = [];
  const customs = [];
  const seen = new Set();
  for (const d of directions || []) {
    const n = String(d.name || "").trim();
    if (!n) continue;
    const key = n.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    if (isOnboardingPresetSport(n)) presets.push(n);
    else customs.push(n);
  }
  return { presets, customs, customDraft: "" };
}
